import Repository from "./repository";

let global = window || global;

class Environment extends Repository {

	constructor(data) {
		super(data);

		// Attach server side setEnv helper
		if (this.server()) {
			let env = this;

			global["setEnv"] = function (data) {
				env.set(data);
			};
		}
	}

	server() {
		return this.get("environment") === "server";
	}

	client() {
		return this.server() === false;
	}

	debug() {
		return this.get("debug", true) === true;
	}

	csrfToken() {
		if (this.server()) {
			return;
		}

		const tokenMeta = document.head.querySelector("meta[name=csrf-token]");
		return tokenMeta ? tokenMeta.content : null;
	}

}

export default new Environment(global.env || {});